module.exports = __webpack_public_path__ + "img/hz5.9264b569.png";